export default __webpack_public_path__ + "static/media/email.5c7905e7.png";